import React, { useMemo } from "react"

import { useDashboardDatePreferences } from "../hooks/useDashboardDatePreferences"
import { DateRangeSelector } from "../widgets/components/DateRangeSelector"

interface CalendarDateRangeButtonProps {
  currentDashboardId?: string
  liveReceiptWindow?: boolean
}

/**
 * Dashboard header date range picker: the shared range selector plus the
 * actions for managing this dashboard's saved default range.
 */
export const CalendarDateRangeButton: React.FC<
  CalendarDateRangeButtonProps
> = ({ currentDashboardId, liveReceiptWindow }) => {
  const {
    savedPreferences,
    saveDatePreference,
    clearDatePreference,
    isSaving,
  } = useDashboardDatePreferences(currentDashboardId)

  const datePreferences = useMemo(
    () =>
      currentDashboardId
        ? {
            savedPreferences,
            saveDatePreference,
            clearDatePreference,
            isSaving,
          }
        : undefined,
    [
      currentDashboardId,
      savedPreferences,
      saveDatePreference,
      clearDatePreference,
      isSaving,
    ],
  )

  return (
    <DateRangeSelector
      datePreferences={datePreferences}
      liveReceiptWindow={liveReceiptWindow}
    />
  )
}
